import { number, string, shape } from 'prop-types';

export default shape({
    label: string.isRequired,
    url: string.isRequired,
    id: number.isRequired,
});
